enum TollProvider {
    EToll = 'ETOLL',
    Linkt = 'LINKT',
}

export default TollProvider;
